import React from 'react';
import PropTypes from 'prop-types';

import {translate} from 'views/module';

import PillDropdown from './PillDropdown';

import userUtil from 'utils/miscellaneous/user/user_util';

const UNASSIGNED = 'UNASSIGNED';

const OwnerDropdown = (props) => {
  const {admins, selectedOwnerRn, setSelectedOwnerRn} = props;

  const unassignedTitle = translate('client.ClientDetail.Status.Menu.OwnerUnassigned');
  const options = [
    [UNASSIGNED, {Title: unassignedTitle}],
    ...admins.map((admin) => [admin.userRn, {Title: userUtil.getFullName(admin.firstName, admin.lastName)}]),
  ];
  const selectedValue = selectedOwnerRn || UNASSIGNED;
  const selectedTitle = options.find(([key]) => key === selectedValue)?.[1].Title;

  return (
    <PillDropdown
      backgroundColor='#FFFFFF'
      borderColor='#D8D3CC'
      label={selectedTitle}
      menuLabel={translate('client.ClientDetail.Status.Menu.Subtitles.Owner')}
      onOpenChange={props.onOverlayChange}
      onOptionSelect={(nextOwner) => {
        if (nextOwner === selectedValue) {
          return;
        }

        setSelectedOwnerRn(nextOwner === UNASSIGNED ? null : nextOwner);
      }}
      options={options}
      selectedValue={selectedValue}
      textColor={selectedOwnerRn ? '#1A1916' : '#7C7C7C'}
    />
  );
};

OwnerDropdown.propTypes = {
  admins: PropTypes.array.isRequired,
  onOverlayChange: PropTypes.func,
  selectedOwnerRn: PropTypes.string,
  setSelectedOwnerRn: PropTypes.func.isRequired,
};

export default OwnerDropdown;
